module.exports = __webpack_public_path__ + "img/craftBannerStair.badd731.webp";